export default __webpack_public_path__ + "static/media/persona-three.9958bc22.webp";